import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

type Params = {
  timePeriod?: string;
  customStartDate?: string;
  customEndDate?: string;
};

export const useGetSalesOverviewQuery = (params: Params) => {
  const token = getToken();

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== "")
  );

  return useQuery({
    queryKey: ["useGetSalesOverviewQuery", filteredParams],
    queryFn: () =>
      axiosInstance
        .get("dashboard/sales-overview", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
